export default __webpack_public_path__ + "static/media/OnData_Default_Roles.f9f9bcc6.png";